import { Layout, Menu } from "antd";
import {
  AppstoreOutlined,
  BarChartOutlined,
  BookOutlined,
  BulbOutlined,
  CalendarOutlined,
  ControlOutlined,
  DollarOutlined,
  FileSearchOutlined,
  FormOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PlayCircleOutlined,
  PhoneOutlined,
  SolutionOutlined,
  TeamOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getEffectivePermissions } from "../../config/pagePermissions";
import LogoSrc from "../../assets/image/logo.svg";
import "../../style/layout/sidebar.scss";

const { Sider } = Layout;

const SidebarSection = ({ collapsed, onToggle }) => {
  const auth = useSelector((state) => state.auth);
  const roles = useSelector((state) => state.permissions.roles);
  const location = useLocation();
  const permissions = getEffectivePermissions(auth.user, roles);
  const canAccess = (key) => permissions.includes(key);
  const item = (key, path, icon, label, allowed = true) =>
    allowed && { key, icon, label: <Link to={path}>{label}</Link> };

  const items = [
    item(
      "/dashboard",
      "/dashboard",
      <AppstoreOutlined />,
      "Dashboard",
      canAccess("dashboard"),
    ),
    item(
      "/applications",
      "/applications",
      <SolutionOutlined />,
      "Applications",
      canAccess("dashboard"),
    ),
    item(
      "/job-board",
      "/job-board",
      <FileSearchOutlined />,
      "Job Board",
      canAccess("dashboard"),
    ),
    item("/bid", "/bid", <FormOutlined />, "Build resume", canAccess("bid")),
    item(
      "/analyze",
      "/analyze",
      <FileSearchOutlined />,
      "Analyze",
      canAccess("analyze"),
    ),
    item(
      "/prompt",
      "/prompt",
      <BulbOutlined />,
      "AI Prompt",
      canAccess("prompt"),
    ),
    item(
      "/calls",
      "/calls",
      <PhoneOutlined />,
      "Interviews",
      canAccess("calls"),
    ),
    item(
      "/calendar",
      "/calendar",
      <CalendarOutlined />,
      "Calendar",
      canAccess("calendar"),
    ),
    item(
      "/personal-statistic",
      "/personal-statistic",
      <BarChartOutlined />,
      "Statistic",
      canAccess("personalStatistic"),
    ),
    item(
      "/team-mate",
      "/team-mate",
      <TeamOutlined />,
      "Team",
      canAccess("teamMates"),
    ),
    { type: "divider" },
    item(
      "/billing",
      "/billing",
      <WalletOutlined />,
      "Billing",
      canAccess("billing"),
    ),
    item("/pricing", "/pricing", <DollarOutlined />, "Pricing"),
    item("/games", "/games", <PlayCircleOutlined />, "Games"),
    item("/guide", "/guide", <BookOutlined />, "Guide"),
    item(
      "/account-settings",
      "/account-settings",
      <ControlOutlined />,
      "Settings",
      canAccess("accountSettings"),
    ),
  ].filter(Boolean);

  return (
    <Sider
      className="app-sidebar"
      width={238}
      collapsedWidth={76}
      collapsed={collapsed}
      trigger={null}
    >
      <div className="sidebar-header">
        <Link to="/" className="sidebar-brand">
          <img src={LogoSrc} alt="" aria-hidden="true" />
          <span>
            Resume <strong>Builder</strong>
          </span>
        </Link>
        <button
          type="button"
          className="sidebar-collapse-toggle"
          onClick={onToggle}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </button>
      </div>
      <div className="sidebar-scroll-content">
        <Menu
          mode="inline"
          inlineCollapsed={collapsed}
          selectedKeys={[location.pathname]}
          items={items}
        />
        <div className="sidebar-workspace-card">
          <span>Workspace</span>
          <strong>Keep every application moving.</strong>
          <Link to="/applications">View applications →</Link>
        </div>
        <Link to="/logout" className="sidebar-logout">
          <LogoutOutlined />
          <span>Sign Out</span>
        </Link>
      </div>
    </Sider>
  );
};

export default SidebarSection;
